import { createContext, useContext } from "react";
import type { User } from "@/lib/types";

export type AuthStatus = "checking" | "authenticated" | "guest" | "unavailable";

export type AuthContextValue = {
	status: AuthStatus;
	user: User | null;
	refresh: () => Promise<User | null>;
	logout: () => Promise<boolean>;
};

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
	const ctx = useContext(AuthContext);
	if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
	return ctx;
}
